var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isRequesting && !_vm.isInitialized
    ? _c(
        "section",
        [_c("spinner-loader", { attrs: { loading: _vm.isRequesting } })],
        1
      )
    : !_vm.isRequesting && !_vm.isRequestingUnits && !_vm.getUnits.length
    ? _c(
        "section",
        [
          _vm._m(0),
          _vm._v(" "),
          _c("b-button", { on: { click: _vm.onClickAddUnit } }, [
            _vm._v(" Add Unit "),
          ]),
        ],
        1
      )
    : _c(
        "section",
        [
          _c(
            "booking-modal",
            { ref: "BookingModal", staticClass: "booking-modal-btn-new" },
            [_c("template", { slot: "submit" })],
            2
          ),
          _vm._v(" "),
          _c("room-rate-modal", {
            ref: "roomRateSelector",
            on: { updated: _vm.reopenBookingModal },
          }),
          _vm._v(" "),
          _vm.getBookings
            ? _c("div", [
                "list" == _vm.reservationViewType
                  ? _c(
                      "div",
                      { staticClass: "table-container" },
                      [
                        _c("div", { staticClass: "date-navigation" }, [
                          _c(
                            "a",
                            {
                              staticClass: "date-arrow",
                              on: { click: _vm.handlePrevious },
                            },
                            [_c("i", { staticClass: "fi-play flip-h" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "today-button",
                              on: { click: _vm.handleToday },
                            },
                            [_vm._v("Today")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "date-container" },
                            [
                              _c("b-form-datepicker", {
                                staticClass: "integrated-picker",
                                attrs: {
                                  "date-format-options": {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                  },
                                },
                                on: { input: _vm.handleDateChange },
                                model: {
                                  value: _vm.selectedDate,
                                  callback: function ($$v) {
                                    _vm.selectedDate = $$v
                                  },
                                  expression: "selectedDate",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "date-arrow",
                              on: { click: _vm.handleNext },
                            },
                            [_c("i", { staticClass: "fi-play" })]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("b-table", {
                          attrs: {
                            items: _vm.filteredBookings,
                            fields: _vm.fields,
                            striped: "",
                          },
                          on: { "row-clicked": _vm.rowClicked },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _c("div", { staticClass: "scheduler-sidebar-ghost" }),
                        _vm._v(" "),
                        _c("scheduler", {
                          ref: "scheduler",
                          attrs: {
                            units: _vm.getUnitTypesList,
                            reservations: _vm.reservations,
                          },
                          on: {
                            "update:units": function ($event) {
                              _vm.getUnitTypesList = $event
                            },
                            "update:reservations": function ($event) {
                              _vm.reservations = $event
                            },
                            renderBookingForm: _vm.renderBookingForm,
                          },
                        }),
                      ],
                      1
                    ),
              ])
            : _vm._e(),
        ],
        1
      )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "mt-5 pt-4" }, [
      _vm._v("\n    You don't have any rental units yet.\n    "),
      _c("br"),
      _vm._v('\n    Create your first one by clicking "Add Unit."\n  '),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }